const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

const handleAddToCart = (form, submitter) => {
  const errorContainer = form.querySelector('.js-atc-error') || document.createElement('div');
  errorContainer.className = 'js-atc-error';
  errorContainer.textContent = '';
  if (!form.contains(errorContainer)) form.appendChild(errorContainer);

  const formData = new FormData(form);
  fetch(`${cartRoot}cart/add.js`, {
    method: 'POST',
    body: formData,
    headers: { Accept: 'application/json' }
  })
    .then((r) => {
      if (!r.ok) return r.json().then((d) => Promise.reject(d.description || 'Error adding to cart'));
      return r.json();
    })
    .then(() => fetch(`${cartRoot}cart.js`))
    .then((r) => r.json())
    .then((cart) => {
      document.dispatchEvent(new CustomEvent('cart:added', { detail: cart }));
      const drawerEl = document.getElementById('CartDrawer');
      if(typeof evaluateCartRules == 'function') {
        evaluateCartRules(cart, function () {
          if (drawerEl && drawerEl.dataset.autoOpen === 'true' && window.CartDrawer) {
            window.CartDrawer.open(cart);
          }
        });
      } else {
        window.CartDrawer.open(cart);
      }
      /*
      if (drawerEl && drawerEl.dataset.autoOpen === 'true' && window.CartDrawer) {
        window.CartDrawer.open(cart);
      }
      */
    })
    .catch((err) => {
      errorContainer.textContent = typeof err === 'string' ? err : 'Error adding to cart';
    });
};

document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  const action = form.getAttribute('action') || '';
  if (!action.includes('/cart/add')) return;
  
  if (form.closest('product-form')) return;

  if (e.submitter && (e.submitter.name === 'checkout' || e.submitter.getAttribute('data-shopify') === 'payment-button')) {
    return; // allow native dynamic checkout
  }
  e.preventDefault();
  handleAddToCart(form, e.submitter);
});

document.addEventListener('shopify:section:load', () => {
  // delegated listener handles new forms automatically
});
